import React from 'react';
import { useTranslation } from 'react-i18next';
import { Routes, Route, NavLink, Navigate } from 'react-router-dom';
import { FileText, DollarSign } from 'lucide-react';
import PreDocumentList from './PreDocumentList';
import PreDocumentDetail from './PreDocumentDetail';
import DriverTariffs from './DriverTariffs';
import './billing.scss';

const TAB_LINKS = [
  { to: '/admin/billing/pre-documents', labelKey: 'Pre-documentos', Icon: FileText },
  { to: '/admin/billing/driver-tariffs', labelKey: 'Tarifas Repartidores', Icon: DollarSign },
];

const BillingView = () => {
  const { t } = useTranslation();
  return (
    <div className="bill">
      {/* Pestañas */}
      <nav className="bill-tabs">
        {TAB_LINKS.map(({ to, labelKey, Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) => `bill-tab${isActive ? ' bill-tab--active' : ''}`}
          >
            <Icon className="w-[18px] h-[18px]" aria-hidden />
            {t(labelKey)}
          </NavLink>
        ))}
      </nav>

      {/* Rutas */}
      <Routes>
        <Route index element={<Navigate to="pre-documents" replace />} />
        <Route path="pre-documents" element={<PreDocumentList />} />
        <Route path="pre-documents/:id" element={<PreDocumentDetail />} />
        <Route path="driver-tariffs" element={<DriverTariffs />} />
        {/* La conexión con Bsale vive en Configuración (microservice-integration, token cifrado).
            La pantalla vieja guardaba el token en claro en billing; se redirige para no romper links. */}
        <Route path="settings" element={<Navigate to="/admin/settings?tab=bsale" replace />} />
      </Routes>
    </div>
  );
};

export default BillingView;
